module.exports = __webpack_public_path__ + "media/landing_work/home/images/mobile_app-4f1eac76e9d6e32196c068531b34b129.svg";